import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Table } from "../../style";

export function TherapeuticMedication(props) {
  return (
    <Table>
      <Header>
        <tr>
          <th style={{ width: "185px" }}>
            <span></span>
          </th>
          <th>
            <span>Qual tipo?</span>
          </th>
          <th>
            <span>Qual Produto?</span>
          </th>
          <th>
            <span>Qual dose?</span>
          </th>
          <th>
            <span>Via Água?</span>
          </th>
        </tr>
      </Header>
      <Body>
        <tr>
          <td>Pré</td>
          <td>
            <Input
              type="inputOnly"
              params="health.therapeuticMedication.pre.type"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Tipo"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="health.therapeuticMedication.pre.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="health.therapeuticMedication.pre.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
          <td>
            <Input
              type="checkbox"
              params="health.therapeuticMedication.pre.water"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
        <tr>
          <td>Inicial</td>
          <td>
            <Input
              type="inputOnly"
              params="health.therapeuticMedication.initial.type"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Tipo"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="health.therapeuticMedication.initial.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="health.therapeuticMedication.initial.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
          <td className="kt-datatable__cell  text-center">
            <Input
              type="checkbox"
              params="health.therapeuticMedication.initial.water"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>

        <tr>
          <td>Crescimento 1</td>
          <td>
            <Input
              type="inputOnly"
              params="health.therapeuticMedication.growth.type"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Tipo"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="health.therapeuticMedication.growth.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="health.therapeuticMedication.growth.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
          <td className="kt-datatable__cell  text-center">
            <Input
              type="checkbox"
              params="health.therapeuticMedication.growth.water"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
        <tr>
          <td>Crescimento 2</td>
          <td>
            <Input
              type="inputOnly"
              params="health.therapeuticMedication.growth2.type"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Tipo"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="health.therapeuticMedication.growth2.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="health.therapeuticMedication.growth2.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
          <td className="kt-datatable__cell  text-center">
            <Input
              type="checkbox"
              params="health.therapeuticMedication.growth2.water"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>

        <tr>
          <td>Final</td>
          <td>
            <Input
              type="inputOnly"
              params="health.therapeuticMedication.final.type"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Tipo"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="health.therapeuticMedication.final.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="health.therapeuticMedication.final.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
          <td className="kt-datatable__cell  text-center">
            <Input
              type="checkbox"
              params="health.therapeuticMedication.final.water"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
      </Body>
    </Table>
  );
}
